import { palette } from '@livable/saas-react-components';
const MuiTypography = {
  styleOverrides: {
    gutterBottom: {
      marginBottom: '24px'
    },
    root: {
      marginBottom: '0',
      color: palette.shades[800],
      whiteSpace: 'pre-line'
    }
  },
  variants: [{
    props: {
      variant: 'body3'
    },
    style: {
      fontSize: '18px',
      lineHeight: '28px',
      fontFamily: palette.fontFamilies.source
    }
  }, {
    props: {
      variant: 'formHint'
    },
    style: {
      fontSize: '16px',
      lineHeight: '24px',
      color: palette.shades[700],
      display: 'flex',
      alignItems: 'center',
      textAlign: 'left',
      transition: "color ".concat(palette.transitions.short),
      '& + .MuiTypography-formHint': {
        marginTop: '4px'
      },
      '.MuiSvgIcon-root': {
        marginRight: '8px',
        path: {
          fill: palette.shades[600]
        }
      },
      '& + .error': {
        color: 'red'
      },
      '&.Mui-error': {
        color: palette.error.main,
        '.MuiSvgIcon-root': {
          path: {
            fill: palette.error.main
          }
        }
      },
      '&.Mui-success': {
        color: palette.success.main,
        '.MuiSvgIcon-root': {
          path: {
            fill: palette.success.main
          }
        }
      }
    }
  }, {
    props: {
      state: 'error'
    },
    style: {
      color: palette.error.main,
      '.MuiSvgIcon-root path': {
        fill: palette.error.main
      }
    }
  }, {
    props: {
      state: 'success'
    },
    style: {
      color: palette.success.main,
      '.MuiSvgIcon-root path': {
        fill: palette.success.main
      }
    }
  }, {
    props: {
      state: 'warning'
    },
    style: {
      color: palette.warning.main,
      '.MuiSvgIcon-root path': {
        fill: palette.warning.main
      }
    }
  }, {
    props: {
      color: 'light'
    },
    style: {
      color: palette.shades[700]
    }
  }, {
    props: {
      color: 'disabled'
    },
    style: {
      color: palette.shades[600]
    }
  }, {
    props: {
      color: 'dark'
    },
    style: {
      color: palette.primary.dark
    }
  }, {
    props: {
      color: 'vibrant'
    },
    style: {
      color: palette.secondary.main
    }
  }, {
    props: {
      color: 'error'
    },
    style: {
      color: palette.error.main
    }
  }, {
    props: {
      color: 'success'
    },
    style: {
      color: palette.success.main
    }
  }, {
    props: {
      color: 'info'
    },
    style: {
      color: palette.info.main
    }
  }, {
    props: {
      color: 'info-dark'
    },
    style: {
      color: palette.info.dark
    }
  }, {
    props: {
      color: 'warning'
    },
    style: {
      color: palette.warning.main
    }
  }, {
    props: {
      color: 'primary'
    },
    style: {
      color: palette.primary.main
    }
  }, {
    props: {
      color: 'white'
    },
    style: {
      color: palette.shades[100]
    }
  }]
};
export default MuiTypography;